import { useEffect, useContext } from "react";

import StepsPagination from "../Content/StepsPagination";
import StepsHeadline from "../Content/StepsHeadline";
import StepsForm from "../Content/StepsForm";
import HelperText from "../Content/HelperText";
import IconInfo from "../../Images/static/media/svg/info.svg";

import CalculatorContext from "../../Context/CalculatorContext";

/* eslint-disable max-len */
function StepNinePage() {
  const {
    setCurrentStepIndex,
    forecastStartYear,
    co2Prices,
    setCo2Prices,
    createDefaultCo2Prices,
    resetCo2Prices,
  } = useContext(CalculatorContext);

  const defaultValues = createDefaultCo2Prices(forecastStartYear);

  useEffect(() => {
    setCurrentStepIndex(8);
  }, [setCurrentStepIndex]);

  return (
    <div className="tx-kalo form-steps-abwizard step-9">
      <div className="frame frame-size-default frame-full frame-background-tertiary">
        <div className="frame-group-container">
          <div className="frame-container frame-container-default">
            <div className="frame-inner frame-inner-space-before-extra-small frame-inner-space-after-medium">
              <StepsPagination />

              <StepsHeadline>
                <h1 className="element-header text-center h4">
                  Welchen{" "}
                  <span className="text-primary">
                    CO<sub>2</sub>-Preis
                  </span>{" "}
                  möchten Sie pro Jahr ansetzen?
                </h1>
              </StepsHeadline>

              <HelperText>
                <p>
                  Mit dem{" "}
                  <strong>
                    CO<sub>2</sub>-Kostenrechner von KALO
                  </strong>{" "}
                  können Sie unterschiedliche Entwicklungen simulieren. Die Preisfelder sind
                  individuell anpassbar, sodass Sie eigene Annahmen und Prognosen für verschiedene
                  Szenarien berechnen können.
                </p>
              </HelperText>

              <div className="frame frame-size-default frame-indent-8 frame-space-after-extra-small">
                <div className="frame-container frame-container-default">
                  <div className="frame-inner">
                    <div className="tx-powermail">
                      <div className="wrap-fluid">
                        <StepsForm>
                          <fieldset className="powermail_fieldset">
                            <div className="inputs-row row justify-content-center">
                              {Object.entries(co2Prices).map(([inputYear]) => {
                                return (
                                  <div
                                    key={inputYear}
                                    className="col-md-6 space-bottom-20 text-center"
                                  >
                                    <fieldset className="form-group">
                                      <div className="powermail_fieldwrap extra-text">
                                        <div className="form-floating">
                                          <input
                                            aria-required="true"
                                            placeholder={`CO2-Preis ${inputYear} (€)*`}
                                            className="form-control form-control-zip-custom powermail_input"
                                            id={`co2-price-${inputYear}`}
                                            type="number"
                                            disabled={inputYear === "2025"}
                                            min={
                                              ["2025", "2026", "2027"].includes(inputYear)
                                                ? 55
                                                : undefined
                                            }
                                            max={
                                              ["2025", "2026", "2027"].includes(inputYear)
                                                ? 65
                                                : undefined
                                            }
                                            required="required"
                                            pattern="\[0-9]*\.?\,?\d{2}"
                                            value={co2Prices[inputYear]}
                                            onKeyDown={(e) => {
                                              if (
                                                ![
                                                  "0",
                                                  "1",
                                                  "2",
                                                  "3",
                                                  "4",
                                                  "5",
                                                  "6",
                                                  "7",
                                                  "8",
                                                  "9",
                                                  "Backspace",
                                                  "Tab",
                                                  "ArrowLeft",
                                                  "ArrowRight",
                                                  "ArrowUp",
                                                  "ArrowDown",
                                                  "Delete",
                                                  "Home",
                                                  "End",
                                                ].includes(e.key) ||
                                                [192, 229].includes(e.keyCode)
                                              ) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                              }
                                            }}
                                            onChange={(e) => {
                                              setCo2Prices({
                                                ...co2Prices,
                                                [inputYear]:
                                                  e.target.value.length > 0
                                                    ? parseFloat(e.target.value)
                                                    : "",
                                              });
                                            }}
                                            onBlur={(e) => {
                                              const value = parseFloat(e.target.value);
                                              if (!e.target.value || e.target.value.trim() === "") {
                                                setCo2Prices({
                                                  ...co2Prices,
                                                  [inputYear]: defaultValues[inputYear].toString(),
                                                });
                                                return;
                                              }
                                              if (["2025", "2026", "2027"].includes(inputYear)) {
                                                if (value > 65) {
                                                  e.target.value = 65;
                                                  setCo2Prices({
                                                    ...co2Prices,
                                                    [inputYear]: "65",
                                                  });
                                                } else if (value < 55) {
                                                  e.target.value = 55;
                                                  setCo2Prices({
                                                    ...co2Prices,
                                                    [inputYear]: "55",
                                                  });
                                                }
                                              }
                                            }}
                                          />

                                          <label htmlFor={`co2-price-${inputYear}`} title="">
                                            CO<sub>2</sub>-Preis {inputYear} (€)
                                            <span className="mandatory">*</span>
                                          </label>
                                        </div>
                                        {Object.keys(co2Prices)[0] === "2025" &&
                                          ["2025", "2026", "2027"].includes(inputYear) && (
                                            <small className="input-info form-text">
                                              {inputYear === "2025"
                                                ? "Festgelegt: 55 €"
                                                : "Zulässig: 55-65 €"}
                                              <a
                                                href="#"
                                                data-bs-target="#floatinTrigerCo2Prices2025"
                                                tabIndex="0"
                                                data-bs-toggle="modal"
                                                className="accordion-button-additional-modal-trigger"
                                                aria-label="Open 2025 co2 prices information  modal"
                                              >
                                                <img
                                                  className="accordion-button-additional-modal-icon"
                                                  src={IconInfo}
                                                  alt=""
                                                />
                                              </a>
                                            </small>
                                          )}
                                        {Object.keys(co2Prices)[0] === "2026" &&
                                          ["2026", "2027"].includes(inputYear) && (
                                            <small className="input-info form-text">
                                              Zulässig: 55-65 €
                                              <a
                                                href="#"
                                                data-bs-target="#floatinTrigerCo2Prices"
                                                tabIndex="0"
                                                data-bs-toggle="modal"
                                                className="accordion-button-additional-modal-trigger"
                                                aria-label="Open co2 prices information  modal"
                                              >
                                                <img
                                                  className="accordion-button-additional-modal-icon"
                                                  src={IconInfo}
                                                  alt=""
                                                />
                                              </a>
                                            </small>
                                          )}
                                      </div>
                                    </fieldset>
                                  </div>
                                );
                              })}
                              <div className="col-12 text-center form-group pt-4 pt-md-3">
                                <input
                                  className="btn btn-step-nine"
                                  type="button"
                                  value="Werte zurücksetzen"
                                  onClick={() => resetCo2Prices()}
                                />
                              </div>
                              <span className="text-center mt-2">*Pflichtfeld</span>
                            </div>
                            <div className="form-group text-center pt-5">
                              <input
                                className="btn btn-secondary"
                                type="submit"
                                value="Prognose berechnen"
                              />
                            </div>
                          </fieldset>
                        </StepsForm>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="frame frame-size-default frame-indent-8 frame-space-after-extra-small">
                <div className="frame-container frame-container-default">
                  <div className="frame-inner">
                    <HelperText>
                      <p>
                        <strong>
                          CO<sub>2</sub>-Preisentwicklung:
                          <br />
                          Auswirkungen & Szenarien vergleichen
                        </strong>
                      </p>
                      <p>
                        {Object.keys(co2Prices)[0] === "2025" && (
                          <span>
                            Der CO<sub>2</sub>-Preis wurde im Jahr 2025 gesetzlich festgelegt auf 55
                            Euro pro Tonne CO<sub>2</sub>.{" "}
                          </span>
                        )}
                        In den Jahren 2026 und 2027 werden Emissionszertifikate erstmalig
                        versteigert. Für diesen Zeitraum gilt ein gesetzlicher Preiskorridor
                        zwischen 55 und 65 Euro pro Tonne CO<sub>2</sub>.
                      </p>
                      <p>
                        Ab dem Jahr 2028 wird der Preis durch den freien Handel im europäischen
                        Emissionshandelssystem (EU-ETS) bestimmt. Expert:innen rechnen damit, dass
                        sich die Preise bis 2030 deutlich erhöhen könnten. In verschiedenen
                        Szenarien ist sogar von bis zu 275 Euro pro Tonne CO<sub>2</sub> die Rede.
                      </p>
                      <p>
                        <strong>Hinweis:</strong> Die voreingestellten CO<sub>2</sub>-Preise im
                        Rechner sind unverbindlich. Sie basieren auf aktuellen Studien und
                        Marktentwicklungen und stellen keine verlässliche Prognose dar. Eine exakte
                        Vorhersage der Preisentwicklung im Rahmen des europäischen Emissionshandels
                        ist zum jetzigen Zeitpunkt nicht möglich.
                      </p>
                    </HelperText>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StepNinePage;
